// extracted by mini-css-extract-plugin
export default {"copyable":"Copyable_copyable__Gy0MZ"};